module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene #sceneViewer #downloadLinks":{"handleDom.logDownload.target":[{"value":"li","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}],"handleDom.logDownload.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}],"handleDom.logDownload.callback":[{"value":function (el, alias, scope) {
var api = this.getApi('loggerApi', {
method: 'logger.log'
});
api.send({
index: 'McUserActivity',
path: fox.Navigator.getAll(),
info: {event: 'download'}
}, false);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.SitePage_Scene #sceneViewer #downloadLinks","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/scene/logger.js
// module id = 677
// module chunks = 4